import React, {Component} from 'react'
import styled, {injectGlobal, css} from 'styled-components'
import {default as SelectField} from 'react-select'
import classNames from 'classnames';
import { Transition } from 'react-transition-group' 
import { bgIcon, hoverState } from '../../styles/global';

class Select extends Component {

    static defaultProps = {
        options: [
            { value: 0, label: 'Test Option #1' },
            { value: 1, label: 'Test Option #2' },
        ]
    }

    state = {
        open: false,
        value: this.props.defaultValue || 0
    }

    renderOption = (option) => {
        return (
            <SelectOption 
                style={{
                    marginTop: option.value !== 0 ? 10 : 0
                }}
                value={option.value}
            >
                {option.label}
            </SelectOption>
        )
    }

    renderMenu = (params) => {
        const { placeholder } = this.props;
        const { optionComponent, options, optionRenderer, inputValue, onOptionRef } = params; 
        
        const Option = optionComponent;

        const newOptions = options.map((option, i) => {
            
            return (
                <Option 
                    {...params}
                    className={'Select-option'}
                    option={option}
                    optionRenderer={this.renderOption}
                    ref={ref => { onOptionRef(ref) }}
                >
                    {optionRenderer(option, i, inputValue)}
                </Option>
            )
        })

        return (    
            <Transition 
                in={this.state.open}
                timeout={this.state.open ? 0 : 200}
            >
                {state => {
                    return (
                        <Dropdown
                            style={{
                                opacity: state == 'entered' ? 1 : 0 
                            }}
                        >
                            <DropdownTop>
                                <DropdownTitle>{placeholder}</DropdownTitle>
                            </DropdownTop>
        
                            <OptionsList>
                                {newOptions}
                            </OptionsList>
                        </Dropdown>
                    )
                }}
            </Transition>
        )

    }
    
    setValue = (value) => {
        const { placeholder } = this.props;

        this.setState({
            value: value.value == 'all' ? 0 : value
        })

        this.props.onSelectChange(value);
    }
    
    render() {
        const { value } = this.state;
        const { options, defaultValue, placeholder } = this.props;

        return (
            <Container
                active={value.label && value.label !== placeholder}
            >   
                <SelectField
                    className={'custom-select'}
                    value={this.state.value}
                    onChange={this.setValue}
                    options={options}
                    searchable={false}
                    clearable={false}
                    placeholder={placeholder}
                    optionRenderer={this.renderOption}
                    menuRenderer={this.renderMenu}
                    closeOnSelect={true}
                    onOpen={() => this.setState({open: !this.state.open})}
                    onClose={() => this.setState({open: !this.state.open})}
                />
            </Container>
        )
    }

}

const Container = styled.div`
    display: flex;
    cursor: pointer;

    ${props => {
        if (props.active) injectGlobal`
            .Select-value {
                color: #5F5F5F !important;
                opacity: 0.7;   
            }
        `
    }}
`;

const SelectOption = styled.div`
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: #807c7c;
    letter-spacing: 1.19px;
    line-height: 11px;
    text-transform: uppercase;
    ${hoverState}
`

const Dropdown = styled.div`
    background: white;
    position: absolute;
    left: 0;
    top: -5px;
    width: 187px;
    min-height: 47px;

    box-sizing: border-box;
    border: 1px solid #F1F1F1;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.03);
    z-index: 10;
    opacity: 0;
    transition: opacity 0.25s ease;
`;

const DropdownTop = styled.div`
    padding: 17px 19px;
    border-bottom: 1px solid #F1F1F1;
`;

const DropdownTitle = styled.div`
    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #929292;
    letter-spacing: 1.28px;
    line-height: 9px;
    text-transform: uppercase;
`;

const OptionsList = styled.div`
    padding: 8px 18px 20px;
`;

injectGlobal`
    .custom-select {
        position: relative;

        .Select-multi-value-wrapper {
            display: flex;
            align-items: center;
        }

        .Select-value, 
        .Select-placeholder {
            font-family: 'Platform-Regular';
            font-size: 14px;
            color: #807c7c;
            letter-spacing: 1.28px;
            line-height: 9px;
            text-transform: uppercase;
            position: relative;
            user-select: none;
        }

        .Select-value::after,
        .Select-placeholder::after {
            content: '↓';
            font-size: 12px;
            ${bgIcon}
            position: absolute;
            right: -18px;
            top: 0;
        }
    }
`

export default Select


// WEBPACK FOOTER //
// ./client/components/Select/Select.js